import Vue from 'vue'
import Vuex from 'vuex'
import global from './global'
import login from './login/login'
import administration from './administration/administration'

Vue.use(Vuex)

export const store = new Vuex.Store({
    modules: {
        global,
        login,
        administration
    }
})



// WEBPACK FOOTER //
// ./src/store/store.js